export default __webpack_public_path__ + "static/media/fail.9ff50c32.webp";